import React from "react";
import "./Wynyard.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Wynyard7images from "../../../Media/BSD/Hiera/Wynyard7";
import Wynyard8images from "../../../Media/BSD/Hiera/Wynyard8";
import Wynyard9images from "../../../Media/BSD/Hiera/Wynyard9";

const imageMap = {
  Wynyard7images,
  Wynyard8images,
  Wynyard9images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Wynyard" className="Wynyard">
      <h1>Welcome to Wynyard</h1>
      <h2>Cicilan Start 18 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
